import { Outlet } from 'react-router-dom'

const Layout = () => {
  return (
    <div className='w-100'>
      <Outlet />
    </div>
  )
}

export default Layout